<template>

    <div class="courses" v-if="dataLoaded && creationOptionsLoaded">

        <h3>Cursos para gestionar</h3>
        <div class="filters">

            <!-- Select coordinator -->
            <div class="filter" v-if="userData.role == 'COORDINADOR_ACADEMICO' || userData.role == 'ADMINISTRADOR'" 
                @click="expandFilter == 'coordinator' ? expandFilter = '' : expandFilter = 'coordinator'"
            >
                <span class="filter-label">{{ params.forgeUserId ? creationOptions.coordinators.find(el=> el.id == params.forgeUserId).fullName : 'Coordinador/a' }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'coordinator'">
                    <template v-for="(coordinator, idx) in creationOptions.coordinators" :key="idx">
                        <li @click="params.forgeUserId = coordinator.id">{{ coordinator.fullName }}</li>
                    </template>
                </ul>
            </div>

            <!-- Select referent -->
            <div class="filter" v-else-if="userData.role == 'COORDINADOR_PEDAGOGICO'"
                @click="expandFilter == 'referent' ? expandFilter = '' : expandFilter = 'referent'"
            >
                <span class="filter-label">{{ params.forgeUserId ? creationOptions.referents.find(el=> el.id == params.forgeUserId).fullName : 'Gestor/a' }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'referent'">
                    <template v-for="(referent, idx) in creationOptions.referents" :key="idx">
                        <li @click="params.forgeUserId = referent.id">{{ referent.fullName }}</li>
                    </template>
                </ul>
            </div>

            <!-- Select course -->
            <div class="filter" v-if="userData.role == 'GESTOR_PLATAFORMA' || userData.role == 'COORDINADOR_PEDAGOGICO' || userData.role == 'ADMINISTRADOR'"
                @click="expandFilter == 'course' ? expandFilter = '' : expandFilter = 'course'"
            >
                <span class="filter-label">{{ params.courseCfgId ? creationOptions.courses.find(course => course.id === params.courseCfgId).name : 'Curso' }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'course'">
                    <template v-for="(course, idx) in creationOptions.courses" :key="idx">
                        <li @click="params.courseCfgId = course.id">{{ course.name }}</li>
                    </template>
                </ul>
            </div>

            <!-- Select status -->
            <div class="filter"
                @click="expandFilter == 'status' ? expandFilter = '' : expandFilter = 'status'"
            >
                <span class="filter-label">{{ params.status == '' ? 'Estado' : $t(`courseInstance.status.${params.status}`) }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'status'">
                    <template v-for="(status, idx) in creationOptions.status" :key="idx">
                        <li @click="params.status = status != 'Todos' ? status : ''">{{ status != 'Todos' ? $t(`courseInstance.status.${status}`) : status}}</li>
                    </template>
                </ul>
            </div>

            <!-- Select courseType -->
            <div class="filter"
                @click="expandFilter == 'courseType' ? expandFilter = '' : expandFilter = 'courseType'"
            >
                <span class="filter-label">{{ params.courseType === '' ? 'Tipo' : $t(`courseInstance.courseTypes.${creationOptions.courseType.find(el=>el.id == params.courseType).name}`) }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'courseType'">
                    <template v-for="(courseType, idx) in creationOptions.courseType" :key="idx">
                        <li @click="params.courseType = courseType.id">{{ courseType.id == '' ? courseType.name : $t(`courseInstance.courseTypes.${courseType.name}`) }}</li>
                    </template>
                </ul>
            </div>

            <!-- Select targetType -->
            <div class="filter"
                @click="expandFilter == 'targetType' ? expandFilter = '' : expandFilter = 'targetType'"
            >
                <span class="filter-label">{{ params.targetType === '' ? 'Público' : creationOptions.targetType.find(el=>el.id == params.targetType).name }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'targetType'">
                    <template v-for="(targetType, idx) in creationOptions.targetType" :key="idx">
                        <li @click="params.targetType = targetType.id">{{ targetType.name }}</li>
                    </template>
                </ul>
            </div>

        </div>
        
        <div ref="table" class="table-pagination">
            <div class="table__container">
                <table class="table">
                    <thead class="table__head">
                        <tr class="table__head__row">
                            <th class="table__head__row__title">CURSO</th>
                            <th class="table__head__row__coordinator" v-if="userData.role == 'COORDINADOR_ACADEMICO' || userData.role == 'ADMINISTRADOR'">COORDINADOR</th>
                            <th class="table__head__row__gestors" v-if="userData.role == 'COORDINADOR_PEDAGOGICO'  || userData.role == 'COORDINADOR_ACADEMICO' || userData.role == 'ADMINISTRADOR'">GESTORES</th>
                            <th class="table__head__row__tutors">FACILITADORES</th>
                            <th class="table__head__row__inscripts">INSCRIPTOS</th>
                            <th class="table__head__row__date">INICIO</th>
                            <th class="table__head__row__status">ESTADO</th>
                            <th class="table__head__row__type">TIPO</th>
                            <th class="table__head__row__type">PÚBLICO</th>
                            <th class="table__head__row__options"></th>
                            <div></div>
                        </tr>
                    </thead>
                    <tbody class="table__body">
                        <tr class="table__body__row" v-for="(row,index) in courses" :key="index">
                            <td class="table__body__row__title" @mouseover="row.titleTooltip = true" @mouseleave="row.titleTooltip = false">
                                {{row.code}} 
                                <span class="title-tooltip" v-if="row.titleTooltip && row.code.length>30">{{row.code}}</span>
                            </td>
                            <td class="table__body__row__coordinator" v-if="userData.role == 'COORDINADOR_ACADEMICO' || userData.role == 'ADMINISTRADOR'">
                                {{ row.coordinators[0] === "" && ' - ' || row.coordinators[0] }}
                                <div @mouseover="coordinatorTooltip[index] = true" @mouseleave="coordinatorTooltip[index] = false" v-if="row.coordinators.length > 1" class="referent_plus">
                                    {{ `+${row.coordinators.length - 1}` }}
                                    <ToolTip 
                                        v-if="coordinatorTooltip[index]"
                                        color="#000"
                                        title="Coordinadores" 
                                        :list="row.coordinators"
                                    />
                                </div>
                            </td>
                            <td class="table__body__row__gestors" v-if="userData.role == 'COORDINADOR_PEDAGOGICO' || userData.role == 'COORDINADOR_ACADEMICO'  || userData.role == 'ADMINISTRADOR'">
                                {{ row.gestors[0] === "" && ' - ' || row.gestors[0] }}
                                <div @mouseover="gestorTooltip[index] = true" @mouseleave="gestorTooltip[index] = false" v-if="row.gestors.length > 1" class="referent_plus">
                                    {{ `+${row.gestors?.length - 1}` }}
                                    <ToolTip
                                        v-if="gestorTooltip[index]"
                                        color="#000"
                                        title="Gestores" 
                                        :html="true" 
                                        :list="row.gestors"
                                    />
                                </div>
                            </td>
                            <td class="table__body__row__tutors">
                                {{ row.tutors[0] === "" && ' - ' || row.tutors[0] }}
                                <div @mouseover="tutorsToolTip[index] = true" @mouseleave="tutorsToolTip[index] = false" v-if="row.tutors.length > 1" class="referent_plus">
                                    {{ `+${row.tutors.length - 1}` }}
                                    <ToolTip 
                                        v-if="tutorsToolTip[index]"
                                        color="#000"
                                        title="Facilitadores" 
                                        :list="row.tutors"
                                    />
                                </div>
                            </td>
                            <td class="table__body__row__inscripts">{{ row.studentInscripted }}</td>
                            <td class="table__body__row__date">{{row.startDate ? formatDate(row.startDate) : '-'}}</td>
                            <td class="table__body__row__status" ><span :class="`--${row.courseStatus}`">{{$t(`courseInstance.status.${row.courseStatus}`)}}</span></td>
                            <td class="table__body__row__type">{{$t(`courseInstance.courseTypes.${row.type}`)}}</td>
                            <td class="table__body__row__type">{{ row.targetType }}</td>
                            <td class="table__body__row__options" @click.stop="modalOptions == row.courseId ? modalOptions = null : modalOptions = row.courseId">
                                <div>
                                    <i class="material-icons">more_vert</i>
                                </div>
                            </td>
                            <div class="table__modal-options" v-if="modalOptions == row.courseId" @click.stop="''">
                                <div @click.stop="router.push(`/course/${row.courseId}/report`)"><i class="material-icons">bar_chart</i>Ir al reporte</div>
                                <div @click.stop="router.push(`/management/courses/participants/${row.courseId}?canBeManaged=${row.canBeManaged}`)"><i class="material-icons">people_outline</i>Gestionar participantes</div>
                                <div @click.stop="router.push(`/management/courses/users/${row.courseId}?canBeManaged=${row.canBeManaged}`)"><i class="material-icons">account_box</i>Gestionar usuarios</div>
                                <div v-if="row.type === 'ON_DEMAND'" @click.stop="copyToClipboard(row.linkCompleteForm)"><i class="material-icons">link</i>Obtener link completo</div>
                                <div v-if="row.canBeManaged" @click.stop="
                                modalModifyEndDate.active = true;
                                modalOptions = null;
                                modalModifyEndDate.courseId = row.courseId;
                                updateDatePicker(new Date(new Date(row.startDate).setHours(0, 0, 0, 0)),row.courseStatus);
                                ">
                                    <i class="material-icons">date_range</i>Modificar fecha de finalización
                                </div>
                                <div v-else @mouseover="tooltipEndDate = true" @mouseleave="tooltipEndDate = false" style="color: #9C9C9C;cursor: default;">
                                    <i class="material-icons">date_range</i>Modificar fecha de finalización
                                    <ToolTip v-if="tooltipEndDate" message="Esta acción debe ser realizada desde el Sistema de Gestión" color="black" />
                                </div>
                                <!-- cursos relacionados -->
                                 <div v-if="row.type === 'ON_DEMAND'" @click.stop="
                                    modalRelatedCourses.active = true;
                                    modalOptions = null;
                                    modalRelatedCourses.courseId = row.courseId;
                                    modalRelatedCourses.currentStep = 1;
                                    getRelatedCourses(row.courseId);
                                    modalRelatedCourses.courseName = row.code;
                                    ">
                                    <i class="material-icons">add_circle</i>Cursos relacionados
                                </div>
                            </div>
                        </tr>
                    </tbody>
                    
                </table>
                <div v-if="!courses.length" style="width:1150px;padding:20px 0 20px 0;text-align:center">No hay resultados para mostrar...</div>
            </div>
            <div class="pagination" v-if="totalResults">
                <button class="prev-next" @click.stop="selectPage('prev')" :disabled="page == 0"><i class="material-icons">arrow_back</i><span>Anterior</span> </button>
                <div class="page"><span>{{ formattedPage }}</span>{{ formattedPages }}</div>
                <button class="prev-next" @click.stop="selectPage('next')" :disabled="page+1 == pages"><span>Siguiente</span> <i class="material-icons">arrow_forward</i></button>
            </div>
        </div>

        <!-- modal to modify course endate  -->
        <div class="modal__overlay" v-if="modalModifyEndDate.active">
            <div class="modal-body modal-body--enddate">
                <i class="material-icons close" @click.stop="modalModifyEndDate.active = false; modalAddStudent.datePickerVisible = false;">close</i>
                <h4>Modificar fecha de finalización del curso</h4>
                <span>Ingrese la nueva fecha de finalización</span>
                <DatePicker 
                    v-if="modalModifyEndDate.datePickerVisible"
                    v-model="modalModifyEndDate.endDate"
                    label="Fecha de finalización"
                    id="endDate"
                    :from="modalModifyEndDate.limitDate"
                    :selectToday="modalModifyEndDate.selectToday"
                    :preselectDate="modalModifyEndDate.preselectDate"
                />
                <div class="buttons">
                    <button @click.stop="modalModifyEndDate.active = false; modalAddStudent.datePickerVisible = false;"><i class="material-icons">arrow_back</i>Atrás</button>
                    <button @click.stop="postEndDate(modalModifyEndDate.courseId)" :disabled="modalModifyEndDate.loading">
                        Continuar<i class="material-icons">arrow_forward</i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Modal cursos relacionados -->
        <div class="modal__overlay" v-if="modalRelatedCourses.active">
            <div class="modal-body modal-body--related-courses">
            <i class="material-icons close" @click.stop="confirmCancelModal = true">close</i>

            <h4>Cursos relacionados</h4>
            <div class="modal-body--related-courses__top">
                <p>
                    <span>
                        Paso {{ modalRelatedCourses.currentStep }} / 2
                    </span>
                     {{ modalRelatedCourses.currentStep == 1 ? 'Selecciona los cursos' : 'Selecciona el orden de los cursos' }}
                </p>
            </div>
            <div class="modal-body--related-courses__subtitule">
                <p v-if="modalRelatedCourses.currentStep == 1">Selecciona <strong>los cursos relacionados</strong> para el curso <strong>{{ modalRelatedCourses.courseName }}</strong></p>
                <p v-if="modalRelatedCourses.currentStep == 2">Selecciona <strong>el orden de los cursos relacionados</strong> para el curso <strong>{{ modalRelatedCourses.courseName }}</strong></p>
            </div>
            <div class="modal-body--related-courses__text">
                <p v-if="modalRelatedCourses.currentStep == 1">Los cursos serán ofrecidos al participante tras haber finalizado el curso actual.</p>
                <p v-if="modalRelatedCourses.currentStep == 2">Los cursos serán ofrecidos al participante en el orden indicado.</p>
            </div>

            <template v-if="modalRelatedCourses.loading">
                <Loader />
            </template>
            <template v-else>
                <template v-if="modalRelatedCourses.currentStep === 1">
                    <div class="table__container-wrapper">
                        <div class="table__container-wrapper__loader" v-if="modalRelatedCourses.tableLoading">
                            <Loader />
                        </div>

                        <div class="table__container" :class="{ 'loading': modalRelatedCourses.tableLoading }">
                            <table class="table">
                                <thead class="table__head">
                                    <tr class="table__head__row">
                                    <th class="table__head__row__check"></th>
                                    <th class="table__head__row__title">CURSO</th>
                                    <th class="table__head__row__end-date">FECHA DE FINALIZACIÓN</th>
                                    </tr>
                                </thead>
                                <tbody class="table__body">
                                    <tr class="table__body__row" v-for="(row, index) in modalRelatedCourses.courses" :key="index">
                                    <td class="table__body__row__check">
                                        <input
                                        type="checkbox"
                                        :checked="row.isAlreadyRelated"
                                        @change="onRelatedCourseChange(row)"
                                        />
                                    </td>
                                    <td
                                        class="table__body__row__title"
                                        @mouseover="row.titleTooltip = true"
                                        @mouseleave="row.titleTooltip = false"
                                    >
                                        {{ row.name }}
                                        <span class="title-tooltip" v-if="row.titleTooltip && row.name.length > 30">
                                        {{ row.name }}
                                        </span>
                                    </td>
                                    <td class="table__body__row__end-date">
                                        {{ row.endDate ? formatDate(row.endDate) : '-' }}
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="buttons">
                        <!-- <button @click.stop="modalRelatedCourses.active = false"> -->
                        <button @click.stop="confirmCancelModal = true">
                            Cancelar
                        </button>
                        <button @click.stop="goToStep(2)" :disabled="!hasSelectedCourses || modalRelatedCourses.loading">
                            Siguiente <i class="material-icons">arrow_forward</i>
                        </button>
                    </div>
                </template>
                <template v-else-if="modalRelatedCourses.currentStep === 2">
                    <!-- Paso 2: Ordenar cursos relacionados -->
                    <!-- <h4>Ordenar cursos relacionados</h4> -->
                    <!-- <span>Ordena los cursos relacionados para el curso <strong>{{ modalRelatedCourses.courseName }}</strong></span> -->
                    <div class="table__container">
                        <table class="table">
                            <thead class="table__head">
                                <tr class="table__head__row">
                                    <!-- Número de orden -->
                                    <th class="table__head__row__order">ORDEN</th>
                                    <th class="table__head__row__title">CURSO</th>
                                    <th class="table__head__row__actions">MODIFICAR</th>
                                </tr>
                            </thead>
                            <tbody class="table__body">
                                <tr class="table__body__row" v-for="(row, index) in modalRelatedCourses.selectedCourses" :key="row.relationshipId">
                                    <td class="table__body__row__order">{{ index + 1 }}</td>
                                    <td class="table__body__row__title">{{ row.courseName }}</td>
                                    <td class="table__body__row__actions">
                                        <button @click="moveCourseUp(index)" :disabled="index === 0">
                                            <i class="material-icons">arrow_upward</i>
                                        </button>
                                        <button @click="moveCourseDown(index)" :disabled="index === modalRelatedCourses.selectedCourses.length - 1">
                                            <i class="material-icons">arrow_downward</i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="buttons">
                        <button @click.stop="goToStep(1)">
                            <i class="material-icons">arrow_back</i> Atrás
                        </button>
                        <button @click.stop="saveOrderedCourses()" :disabled="modalRelatedCourses.loading">
                            Guardar
                        </button>
                    </div>
                </template>
            </template>
            </div>
        </div>
        <!-- Modal de confirmación para cancelar selección de cursos relacionados -->
        <div class="modal__overlay" v-if="confirmCancelModal">
            <div class="modal-body modal-body--confirm-cancel">
                <i class="material-icons close" @click.stop="confirmCancelModal = false">close</i>
                <h4>¿Deseas <strong>cancelar</strong> la selección de cursos relacionados?</h4>
                <span>
                    Se perderán toda la información que has cargado.<br>
                    Esta acción no se puede deshacer.
                </span>
                <div class="buttons">
                    <button @click.stop="confirmCancelModal = false" class="buttons__cancel">No, volver</button>
                    <button @click.stop="confirmCancel()">Sí, cancelar</button>
                </div>
            </div>
        </div>


    </div>
    <Loader v-else />

</template>

<script>
import { inject, onMounted, onBeforeUnmount, ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Loader from '@/components/Loader.vue';
import DatePicker from '@/components/Inputs/DatePicker.vue';
import useVuelidate from '@vuelidate/core';
import { email } from '@vuelidate/validators';
import persistentData from '@/plugins/persistentData';
import ToolTip from '../../../components/ToolTip.vue';

export default {
    components: {
        Loader,
        DatePicker,
        ToolTip
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const v$ = useVuelidate();
        const formatDate = inject('formatDate');
        const copyToClipboard = inject('copyToClipboard');
        const modalOptions = ref(null)
        const userData = persistentData.get('user', true)
        const courses = ref();
        const creationOptions = ref([])
        const dataLoaded = ref(false);
        const creationOptionsLoaded = ref(false);
        const coordinatorTooltip = ref({})
        const tutorsToolTip = ref({})
        const gestorTooltip = ref({})
        const tooltipEndDate = ref(false);
        const modalAddStudent = ref({
            active: null,
            fullData: false,
            email: '',
            firstName: '',
            lastName: '',
            countryId: null
        });
       const modalModifyEndDate = ref({
            active: false,
            courseId: null,
            endDate: '',
            loading: false,
            limitDate: new Date(),
            selectToday: false,
            preselectDate: '',
            datePickerVisible: false
        });
        const modalRelatedCourses = ref({
            active: false,
            courseId: null,
            courseName: '',
            loading: false,
            tableLoading: false,
            courses: [],
            selectedCourses: [],
            currentStep: 1,
        });

        const confirmCancelModal = ref(false);

        const hasSelectedCourses = computed(() => {
            return modalRelatedCourses.value.courses.some(course => course.isAlreadyRelated);
        });

        watch(modalAddStudent.value, ()=>{
            if(!modalAddStudent.value.active){
                modalAddStudent.value.fullData = false;
                modalAddStudent.value.email = '';
                modalAddStudent.value.firstName = '';
                modalAddStudent.value.lastName = '';
                modalAddStudent.value.countryId = null;
            }
        })

        const expandFilter = ref('');
        const totalResults = ref();
        const remainResults = ref();
        const pages = ref();
        const page = ref(0); 

        const params = ref({
            rows: 5,
            forgeUserId: '',
            status: '',
            country: '',
            courseCfgId: '',
            courseType: '',
            targetType: '',
        })

        watch(
            () => params.value, 
            () => {
                page.value = 0;
                getCourses();
            }, 
            { deep: true }  
        );

        function selectPage(prevNext){
            if(prevNext == 'next') page.value++;
            else if(prevNext == 'prev') page.value--;
            getCourses()
        }

        const formattedPage = computed(() => {
            return 'Página ' + (page.value + 1 < 10 ? '0' + (page.value + 1) : page.value + 1);
        });

        const formattedPages = computed(() => {
            return ' / ' + (pages.value < 10 ? '0' + pages.value : pages.value);
        });

        function updateDatePicker(date,status){
            modalModifyEndDate.value.datePickerVisible = false;
            if (status == 'NotStarted') {
                modalModifyEndDate.value.selectToday = false;
                modalModifyEndDate.value.limitDate = date;
                modalModifyEndDate.value.endDate = date;
                modalModifyEndDate.value.preselectDate = date;
                modalModifyEndDate.value.datePickerVisible = true;
            } else {
                modalModifyEndDate.value.limitDate = new Date(new Date().setHours(0, 0, 0, 0));
                modalModifyEndDate.value.selectToday = true;
                modalModifyEndDate.value.preselectDate = '';
                modalModifyEndDate.value.datePickerVisible = true;
            }
            setTimeout(()=>{modalModifyEndDate.value.datePickerVisible = true}, 0)
        }

        async function getCreationOptions(){
            try {
                creationOptionsLoaded.value = false; 
                let req = await store.dispatch('preRegistration_creationOptions');
                creationOptions.value = req.data;
                creationOptions.value.countries.push({id: 0, name: 'Todos'})
                creationOptions.value.coordinators.push({id: '', fullName: 'Todos'})
                creationOptions.value.referents.push({id: '', fullName: 'Todos'})
                creationOptions.value.courseType.push({id: '', name: 'Todos'})
                creationOptions.value.targetType.push({id: '', name: 'Todos'})
                creationOptions.value.status = ['Finished', 'NotStarted', 'InProgress', 'Todos']
                creationOptions.value.courses.push({id: '', name: 'Todos'})
                creationOptionsLoaded.value = true;                
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al cargar opciones de filtros' });
            }
        }

        async function getCourses(){
            try {
                dataLoaded.value = false;
                let filters = { ...params.value };
                filters.page = page.value;
                let req = await store.dispatch('coursesInstances_getCourses', filters);
                courses.value = req.data.data;
                totalResults.value = req.data.totalResults;
                remainResults.value = req.data.totalResults - (page.value * params.value.rows);
                pages.value = Math.ceil(req.data.totalResults / params.value.rows);
                dataLoaded.value = true;                
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create',{text: 'Error al obtener cursos'});
            }
        }

        async function getRelatedCourses(sourceId){
            // loading
            modalRelatedCourses.value.loading = true;
            try {
                let req = await store.dispatch('coursesInstances_getRelatedCoursesOptions', sourceId);
                modalRelatedCourses.value.courses = req.data;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create',{text: 'Error al obtener cursos relacionados'});
            }
            modalRelatedCourses.value.loading = false;
        }

        async function onRelatedCourseChange(row) {
            // Determine action based on isAlreadyRelated
            if (row.isAlreadyRelated) {
                // Remove related course
                await removeRelatedCourse(row.id, row);
            } else {
                // Add related course
                await addRelatedCourse(row.id, row);
            }
        }

        async function addRelatedCourse(destinationId, row) {
            modalRelatedCourses.value.tableLoading = true; // Cambiado
            try {
                await store.dispatch('coursesInstances_addRelatedCourse', {
                    sourceId: modalRelatedCourses.value.courseId,
                    destinationId,
                });
                store.dispatch('notifications_create', { text: 'Curso relacionado agregado correctamente' });
                row.isAlreadyRelated = true;
            } catch (error) {
                console.error(error);
                store.dispatch('notifications_create', { text: 'Error al agregar curso relacionado' });
                row.isAlreadyRelated = false;
            }
            modalRelatedCourses.value.tableLoading = false; // Cambiado
        }

        async function removeRelatedCourse(destinationId, row) {
            modalRelatedCourses.value.tableLoading = true; // Cambiado
            try {
                await store.dispatch('coursesInstances_removeRelatedCourse', {
                    sourceId: modalRelatedCourses.value.courseId,
                    destinationId,
                });
                store.dispatch('notifications_create', { text: 'Curso relacionado eliminado correctamente' });
                row.isAlreadyRelated = false;
            } catch (error) {
                console.error(error);
                store.dispatch('notifications_create', { text: 'Error al eliminar curso relacionado' });
                row.isAlreadyRelated = true;
            }
            modalRelatedCourses.value.tableLoading = false; // Cambiado
        }


        async function goToStep(step) {
            if (step === 2) {
                // Antes de pasar al paso 2, carga los cursos relacionados ordenados
                await loadOrderedCourses();
            }
            modalRelatedCourses.value.currentStep = step;
        }

        async function loadOrderedCourses() {
            modalRelatedCourses.value.loading = true;
            try {
                let response = await store.dispatch('courses_getOrder', modalRelatedCourses.value.courseId);
                // La respuesta es un array de cursos relacionados con su orden actual
                modalRelatedCourses.value.selectedCourses = response.data;
            } catch (error) {
                console.error(error);
                store.dispatch('notifications_create', { text: 'Error al obtener el orden de cursos relacionados' });
            }
            modalRelatedCourses.value.loading = false;
        }

        function moveCourseUp(index) {
            if (index > 0) {
                const temp = modalRelatedCourses.value.selectedCourses[index];
                modalRelatedCourses.value.selectedCourses.splice(index, 1);
                modalRelatedCourses.value.selectedCourses.splice(index - 1, 0, temp);
            }
        }

        function moveCourseDown(index) {
            if (index < modalRelatedCourses.value.selectedCourses.length - 1) {
                const temp = modalRelatedCourses.value.selectedCourses[index];
                modalRelatedCourses.value.selectedCourses.splice(index, 1);
                modalRelatedCourses.value.selectedCourses.splice(index + 1, 0, temp);
            }
        }

        async function saveOrderedCourses() {
            modalRelatedCourses.value.loading = true;
            try {
                const orderedRelationshipIds = modalRelatedCourses.value.selectedCourses.map(course => course.relationshipId);
                await store.dispatch('courses_setOrder', {
                    sourceId: modalRelatedCourses.value.courseId,
                    orderedRelationshipIds,
                });
                store.dispatch('notifications_create', { text: 'Cursos relacionados guardados con éxito.' });
                modalRelatedCourses.value.active = false;
            } catch (error) {
                console.error(error);
                store.dispatch('notifications_create', { text: 'Error al actualizar el orden de cursos relacionados' });
            }
            modalRelatedCourses.value.loading = false;
        }

        function confirmCancel() {
            modalRelatedCourses.value.active = false;
            confirmCancelModal.value = false;
            // Restablece los datos si es necesario
            modalRelatedCourses.value.currentStep = 1;
            modalRelatedCourses.value.courses.forEach(course => {
                course.isAlreadyRelated = false;
            });
            modalRelatedCourses.value.selectedCourses = [];
        }

        async function postEndDate(courseId) {
            modalModifyEndDate.value.loading = true;
            try {
                const body = {
                    courseId,
                    endDate: modalModifyEndDate.value.endDate
                }
                // coursesInstances_modifyEndDate
                await store.dispatch('coursesInstances_modifyEndDate', body);
                store.dispatch('notifications_create', {text: 'Fecha de finalización modificada correctamente'});
                getCourses();
                modalModifyEndDate.value.active = false;
                modalModifyEndDate.value.loading = false;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', {text: 'Error al modificar fecha de finalización'});
                modalModifyEndDate.value.loading = false;
            }
        }

        const closeModals = (e)=> { 
            if(!e.target.matches('.table__modal-options')){
                modalOptions.value = null;
            }
            if(!e.target.matches('.filter') && !e.target.matches('.filter-label') && !e.target.matches('.filter-icon')){
                expandFilter.value = '';
            }
        }

        onMounted(()=>{
            getCreationOptions();
            getCourses();
            document.addEventListener('click', closeModals);
            document.body.style.overflowX = 'auto';
            document.body.style.background = '#fff';
        })
        onBeforeUnmount(()=>{
            document.removeEventListener('click', closeModals);
            document.body.style.overflowX = 'visible';
            document.body.style.background = '';

        })

        return{
            router,
            v$,
            formatDate,
            copyToClipboard,
            courses,
            dataLoaded,
            creationOptionsLoaded,
            modalOptions,
            getCourses,
            modalAddStudent,
            creationOptions,
            selectPage,
            totalResults,
            pages,
            page,
            params,
            userData,
            coordinatorTooltip,
            gestorTooltip,
            tutorsToolTip,
            tooltipEndDate,
            formattedPage,
            formattedPages,
            modalModifyEndDate,
            postEndDate,
            updateDatePicker,
            modalRelatedCourses,
            getRelatedCourses,
            onRelatedCourseChange,
            goToStep,
            moveCourseUp,
            moveCourseDown,
            saveOrderedCourses,
            addRelatedCourse,
            removeRelatedCourse,
            loadOrderedCourses,
            hasSelectedCourses,
            confirmCancel,
            confirmCancelModal,
            expandFilter
        }
    },
    validations () {
        return {
            modalAddStudent: {
                email: { email }
            }            
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.table__modal-options{
    position: absolute;
    right: 2px;
    min-width: 224px !important;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 8000;
    >div{
        padding: 4px 22px;
        @include icon-and-text-container;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        &:hover{
            background: rgba(189, 228, 228, 0.5);
        }
    }
}

.referent_plus{
    font-weight: 700;
    font-size: 16px;
    color: $green;
}

.dropdown{
    &__items{
        padding: 8px 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
        background: #fff;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        z-index: 2;
        font-size: 13px;
        font-weight: 600;
        border: none;
        li{
            padding: 4px 24px;
            cursor: pointer;
            &:hover{
                background: rgba(189, 228, 228, 0.5);
            }
        }
        @media screen and (max-width: 750px) {
            right: 0 !important;
        }
    }
}

.courses{
    h3{
        font-size: 20px;
    }
    .filters{
        margin: 24px 0 16px 0;
        display: flex;
        justify-content: space-evenly;
        gap: 16px;
        .filter{
            position: relative;
            font-weight: 500;
            font-size: 13px;
            position: relative;
            width: 200px;
            padding: 6px 12px;
            border: 1px solid #212121;
            border-radius: 25px;
            span{
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            ul{
                position: absolute;
                width: 100%;
                top: 42px;
                left: 0;
                z-index: 4000;
                background: #fff;
                padding: 4px 12px;
                border: 1px solid #212121;
                border-radius: 12px;
                li{
                    padding: 0px 0;
                    margin: 8px 0;
                    cursor: pointer;

                }
            }
        }
    }

    .table-pagination {
        border-radius: 10px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    }

    .table {
        width: 100%;
        position: relative;
        margin-top: 8px;
        padding: 16px;
        padding-bottom: 0;
        @media (max-width: 980px) {
            .table__container {
                overflow-x: auto;
            }
        }
        th, td {
            padding: 14px;
        }
        &__head {
            
            &__row {
                th {
                    // overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-weight: 600;
                    font-size: 12px;
                    text-align: left;

                    &.table__head__row__options {
                        padding-right: 0;
                        padding-left: 0;
                    }

                    &.table__head__row__title {
                        padding-left: 0;
                    }      
                    &.table__head__row__stage {
                    position: relative;

                    .material-icons-outlined{
                        font-size: 12px;
                    }
                    .stage-tooltip{
                        width: 200px;
                        position: absolute;
                        right: -36px;
                        padding: 18px 14px 26px 14px;
                        background: #BDE4E4;
                        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                        border-radius: 10px;
                        text-align: left;
                        font-size: 11px;
                        font-weight: 400;
                        z-index: 100;
                        h4{
                            padding-bottom: 4px;
                            font-size: 13px;
                            font-weight: 700;
                        }
                    }
                }
                }
            }
        }

        &__body {
            tr {
                td {
                    max-width: 170px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 11px;
                    text-align: left;
                    border-bottom: 1px solid #eee;
                    &.table__body__row__title {
                        font-weight: 600;
                        font-size: 12px;
                        padding-left: 0;
                        .title-tooltip {
                            width: 300px;
                            position: absolute;
                            left: 210px;
                            margin-top: -16px;
                            padding: 16px;
                            background: #BDE4E4;
                            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                            border-radius: 10px;
                            text-align: left;
                            font-size: 11px;
                            font-weight: 400;
                            z-index: 100;
                            font-weight: 700;
                            text-wrap: wrap;
                        }
                    }

                    &.table__body__row__status{
                        // padding-top: 4px !important;
                        text-align: center;
                        span{
                            display: inline-block;
                            // width: 100px;
                            width: 100%;
                            padding: 4px 16px;
                            border-radius: 50px;
                            font-size: 12px;
                            font-weight: 600;
                            text-align: center;
                            &.--Finished{
                                color: $green;
                                background: rgba(189, 228, 228, 0.5);
                            }
                            &.--InProgress{
                                background: #EFE2EE;
                                color: #9E5498;
                            }
                            &.--NotStarted{
                                color: #FFB23F;
                                background: rgba(255, 178, 63, 0.15);
                            }
                        }
                    }

                    &.table__body__row__type{
                        font-size: 11px;
                        font-weight: 600;	
                    }

                    &.table__body__row__options {
                        font-size: 12px;
                        font-weight: 600;
                        cursor: pointer;
                        padding-left: 0;
                        padding-right: 0;
                        width: 28px;
                        div {
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                        }            
                    }
                }
            }
        }

    }
    .pagination{
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 24px 16px;
        .prev-next{
            @include icon-and-text-container;
            font-size: 15px;
            font-weight: 600;
            color: $green;
            line-height: 20px;
            &:disabled{
                cursor: default;
            }
            .material-icons{
                font-size: 20px;
            }
        }
        .page{
            font-size: 15px;
            font-weight: 400;
            span{
                font-weight: 700;
            }
        }
    }
    .modal-body{
        width: 100%;
        max-width: 420px;
        position: relative;
        padding: 42px;
        display: flex;
        flex-direction: column;
        gap: 18px;
        background: #FFFFFF;
        box-shadow: 5px 5px 35px rgba(217, 217, 217, 0.5);
        border-radius: 10px;
        .close{
            position: absolute;
            top: 16px;
            right: 16px;
            cursor: pointer;
        }
        h4{
            padding-bottom: 4px;
            margin-top: -6px;
            font-weight: 700;
            font-size: 16px;
        }
        span{
            font-weight: 400;
            font-size: 13px;
        }
        .buttons{
            display: flex;
            justify-content: center;
            gap: 24px;
            padding-top: 16px;
            button{
                width: 152px;
                padding: 8px 0;
                @include icon-and-text-container;
                justify-content: center;
                border-radius: 44px;
                font-weight: 600;
                font-size: 16px;
                &:first-child{
                    border: 1px solid $green;
                    color: $green;
                }
                &:last-child{
                    background: $green;
                    color: #fff;
                }
            }
        }

        &--related-courses{
            width: 100%;
            max-width: 600px;
            padding: 24px;

            .table__container {
                width: 100%;
            }
            
            .table__container-wrapper {
                position: relative;
                width: 100%;
            }

            .table__container-wrapper__loader {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                z-index: 2;
            }

            .table__container.loading {
                opacity: 0.5; /* Opcional: para dar efecto de deshabilitado */
            }

            .modal-body--related-courses__top {
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                padding: 16px;
                p {
                    font-size: 12px;
                    font-weight: 600;
                    color: $black;
                    margin: 0;
                    display: flex;
                    align-items: center;
                    gap: 16px;

                    span {
                        font-weight: 700;
                        color: $green;
                    }
                }
                &::after {
                    content: '';
                    position: absolute;
                    bottom: -8px;
                    left: 0;
                    right: 0;
                    height: 8px;
                    width: 100%;
                    background: linear-gradient(180deg, rgba(0, 0, 0, 0.05), transparent);
                }
            }

            .modal-body--related-courses__subtitule {
                p {
                    font-size: 16px;
                    font-weight: 600;
                }
                strong {
                    color: $green;
                }
            }

            .modal-body--related-courses__text {
                p {
                    font-size: 14px;
                    font-weight: 400;
                }
            }

            .table__container{
                max-height: 50vh;
                overflow-y: auto;
                overflow-x: auto;
                position: relative;
                // scrollbar
                &::-webkit-scrollbar {
                    width: 4px;
                }
                &::-webkit-scrollbar-track {
                    background: #f1f1f1;
                }
                &::-webkit-scrollbar-thumb {
                    border-radius: 100px;
                    background: #a4a4a4;
                }
                .table {
                    padding: 0;

                    .table__body {
                        .table__body__row {
                            .table__body__row__check {
                                width: 40px;
                            }

                            .table__head__row__end-date {
                                width: 0;
                            }

                            td {
                                font-size: 16px;
                                font-weight: 400;
                            }

                        }
                    }
                }
            }
            .black-overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.15);
                z-index: 1;
            }
            /* Ensure the parent elements allow overflow */
            .table__body__row__check {
                overflow: visible;
            }
        }
        &--confirm-cancel {
            text-align: center;
            h4 {
                strong {
                    color: $green;
                }
            }

            .buttons {
                &__cancel {
                    border: none!important;
                }
            }
        }
    }
}
</style>